export function norwegianPrice(
  value: number | string | null | undefined,
  round = true,
  withKrPrefix = false,
) {
  value ||= 0

  if (Number.isNaN(Number(value))) {
    return value
  }

  let price = value.toLocaleString('nb-NO', {
    style: 'currency',
    currency: 'NOK',
    maximumFractionDigits: round ? 0 : 2,
    minimumFractionDigits: 0,
  })

  if (!withKrPrefix) {
    price = price.replace('kr', '').trim()
  }

  if (round || Number.isInteger(value)) {
    price += ',\u2011'
  }

  return price
}
